export default __webpack_public_path__ + "static/media/filthy-rich.c3b4efbb.svg";